import dynamic from "next/dynamic";
const OnlyImageGridComponent = dynamic(()=>import("./only-image-grid-component"));
import OnlyImageGridConfig from "./only-image-grid-config";
import OnlyImageGridAdvancedConfig from "./only-image-grid-advanced-config";
export default {
    OnlyImageGridComponent,
    OnlyImageGridConfig,
    OnlyImageGridAdvancedConfig
};
